"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassBreakRenderer = void 0;
var axios_1 = __importDefault(require("axios"));
var date_fns_1 = require("date-fns");
;
var LOCALSTORAGE_KEY_CLASS_BREAK_RENDERER = 'WildfireAppClassBreakRendererInfo';
var getRendererFromLocalStorage = function () {
    var OLD_LOCALSTORAGE_KEY_CLASS_BREAK_RENDERER = 'classBreakRendererInfo';
    localStorage.removeItem(OLD_LOCALSTORAGE_KEY_CLASS_BREAK_RENDERER);
    var itemFromLocalStorage = localStorage.getItem(LOCALSTORAGE_KEY_CLASS_BREAK_RENDERER)
        ? JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY_CLASS_BREAK_RENDERER))
        : null;
    if (!itemFromLocalStorage) {
        return null;
    }
    var expiration = itemFromLocalStorage.expiration, data = itemFromLocalStorage.data;
    var hasExpired = date_fns_1.isAfter(new Date(), new Date(expiration));
    return !hasExpired && data ? data : null;
};
var save2LocalStorage = function (data) {
    var expiration = date_fns_1.add(new Date(), {
        days: 2
    }).getTime();
    if (data) {
        var data2Save = {
            data: data,
            expiration: expiration
        };
        localStorage.setItem(LOCALSTORAGE_KEY_CLASS_BREAK_RENDERER, JSON.stringify(data2Save));
    }
};
exports.getClassBreakRenderer = function (_a) {
    var url = _a.url, classificationField = _a.classificationField, _b = _a.breakCount, breakCount = _b === void 0 ? 5 : _b, _c = _a.where, where = _c === void 0 ? '1=1' : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var cachedData, requestUrl, response, data;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    cachedData = getRendererFromLocalStorage();
                    if (cachedData) {
                        return [2, cachedData];
                    }
                    requestUrl = url + '/generateRenderer';
                    return [4, axios_1.default.get(requestUrl, {
                            params: {
                                classificationDef: {
                                    type: "classBreaksDef",
                                    breakCount: breakCount,
                                    classificationField: classificationField,
                                    classificationMethod: "esriClassifyNaturalBreaks"
                                },
                                where: where,
                                f: 'json'
                            }
                        })];
                case 1:
                    response = _d.sent();
                    data = response.data;
                    save2LocalStorage(data);
                    return [2, data];
            }
        });
    });
};
